import { render, staticRenderFns } from "./EditDocLabOrga.vue?vue&type=template&id=79e94fad&scoped=true"
import script from "./EditDocLabOrga.vue?vue&type=script&lang=js"
export * from "./EditDocLabOrga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e94fad",
  null
  
)

export default component.exports